import { render, staticRenderFns } from "./TeacherCalendarManaged.vue?vue&type=template&id=a2297ea6&"
import script from "./TeacherCalendarManaged.vue?vue&type=script&lang=js&"
export * from "./TeacherCalendarManaged.vue?vue&type=script&lang=js&"
import style0 from "./TeacherCalendarManaged.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports